import { GridCellParams } from '@mui/x-data-grid-pro'
import { InstitutionLogo, Text } from '@mxenabled/mxui'
import Stack from '@mui/material/Stack'

import { AccountTypeName, type Account } from '../../../core'

export const AccountCell = (params: GridCellParams) => {
  const account = params.row.account as Account
  const accountType = AccountTypeName[account.account_type]

  return (
    <Stack alignItems="center" flexDirection="row">
      <InstitutionLogo
        alt={`${account.institutionName}`}
        institutionGuid={account.institution_guid || ''}
      />
      <Stack ml={12}>
        <Text variant="body2">{account.name}</Text>
        <Text variant="caption">{accountType}</Text>
      </Stack>
    </Stack>
  )
}

export default AccountCell
